import { autoinject } from 'aurelia-framework';
import { ToastService } from 'services/toast-service';
import { connectTo } from 'aurelia-store';
import { ApplicationState } from 'lib/state';

@autoinject
@connectTo()
export class adminOverview {
  private adminViews: Array<Object> = [];
  protected state: ApplicationState;
  protected isSuperService: boolean = false;
  protected isMooringAdministator: boolean = false;
  protected isPenAdministator: boolean = false;
  protected isAdministrator: boolean = false;
  protected isPlm: boolean = false;
  constructor(private toastService: ToastService) {
    this.adminViews = [
      {
        'name-t': 'admin.system_administration',
        views: [
          {
            t: 'admin.user_administration',
            route: 'user-list',
          },
          {
            t: 'general.servicestation',
            route: 'service-station-list',
          },
        ],
      },
    ];
  }

  private attached() {
    if (this.state.roles.includes('SuperService') && !this.state.roles.includes('Administrator')) {
      this.isSuperService = true;
    }

    if (this.state.roles.includes('MooringAdministrator') && !this.state.roles.includes('Administrator')) {
      this.isMooringAdministator = true;
    }

    if (this.state.roles.includes('PensAdministrator') && !this.state.roles.includes('Administrator')) {
      this.isPenAdministator = true;
    }

    if (this.state.roles.includes('Administrator')) {
      this.isAdministrator = true;
    }

    if (this.state.user.Email === 'ingrid.johanne.hoydal@morenot.com' || this.state.user.Email === 'ulrik.eikas@twoday.com') {
      this.isPlm = true;
    }
  }

  private showAppexMessage() {
    this.toastService.showError('general.controlledByAppex');
  }
}
